var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('div',{staticClass:"v2026-chiprow"},[_c('span',{staticClass:"v2026-chiprow__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"v2026-chiprow__row"},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,staticClass:"v2026-chiprow__chip"},[_vm._v(_vm._s(item))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }